import { Injectable } from '@angular/core';
import { DatabaseGwService } from '../database-gw.service';

@Injectable({
  providedIn: 'root'
})
export class UserService extends DatabaseGwService {

  URL_PATH: string = "/users";

  getAllBranchUsers(filter:any = {}){
    return this.query(filter, '/branch-user');
  }
 
}

